<script>
import { mapState, mapGetters } from 'vuex';

import { BIconTrash,BBadge, BIconSearch, BIconBack, BSpinner,BIconPeopleFill } from 'bootstrap-vue';

import formatDate from '@/mixins/formatDate';
import toast from '@/mixins/toast';
import trialHelpers from '@/mixins/trialHelpers';
import subscriptionHelpers from '@/mixins/subscriptionHelpers';
import agreementTitle from '@/lib/agreement-title';
import { analytics } from '../../firebase';
import TrialBanner from '../../components/TrialBanner.vue';
import ClioImport from '../../clioImport.vue';
import {hasEditPermission, hasDeletePermission, hasAddPermission, currentRoleLevelName} from '@/mixins/roleLevelPermissions';
import SubscriptionModal from '../../components/SubscriptionModal.vue';
import subsciptionHelpers from '@/mixins/subscriptionHelpers';

export default {
	name: 'AgreementsHome',
	components: {
		BIconTrash,
		TrialBanner,
		BBadge,
		ClioImport,
		BIconSearch,
		BIconBack,
		BSpinner,
		BIconPeopleFill,
		SubscriptionModal
	},
	data() {
		return {
			fields: [
				{
					class: 'checkbox',
					key: 'checkBox',
					label: '',
				},
				{
					class: 'nameColumn',
					key: 'name',
					sortable: true,
				},
				{
					class: 'descriptionColumn',
					key: 'description',
					sortable: false,
				},
				{
					class: 'dateColumn',
					key: 'updatedAt',
					label: 'Last edited',
					formatter: this.dateFormatter,
					sortable: true
				},
				{
					class: 'deleteColumn',
					key: 'delete',
					label: '',
				},
				{
					class: 'duplicateColumn',
					key: 'duplicate',
					label: '',
				},
			],
			showDeleteConfirmation: false,
			showDuplicateConfirmation: false,
			deleteId: null,
			duplicateId: null,
			showAgreementLimit: false,
			agreementLimitModalOptions: {
				heading:'',
				message:'',
				button:'',
			},
			agreementDeleteModalOptions: {
				heading:'',
				message:'',
			},
			agreementDuplicateModalOptions: {
				heading:'',
				message:'',
			},
			checkedAgreements: [],
			selectAll: false,
			deleteMultiple: false,
			deleteLoader:false,
			searchTerm:'',
			showClioModal:false,
			saveDetails: false,
			clioLoading:false,
			showAddClient:false,
			loading: false,
			duplicateAgreementTitle:'',
			duplicateAgreementDetails: [],
			iscloned: false,
			clonedId:'',
			cloning:false,
			cloningStatus: {},
			showSubscriptionModal:false,
			showLearnButton: false
		};
	},
	methods: {
		agreementTitle,
		// addNewClientMethod(){
		// 	if(this.validateSubscriptionLimitReached.limitReached){
		// 				this.showAgreementLimit = true;
		// 				this.agreementLimitModalOptions={
		// 					heading:'Plan limit reached',
		// 					message : `Oops! It looks like you've already created ${this.subscriptions[0].role.substring(0,1)} new agreements this month. Need to create more files fast? Upgrade to Pro and create unlimited new files whenever you need.`,
		// 					button:"Upgrade Now"
		// 				}
		// 				return;
		// 	} else if(this.validateTrialAgreementsEnded()){
		// 		this.showAgreementLimit = true;
		// 		this.agreementLimitModalOptions={
		// 			heading:'Trial Limit',
		// 			message : "You're currently on a Divii Free Trial which only supports one client file. If you'd like to create more files, you can upgrade to a paid version of Divii.",
		// 			button: "Subscribe"
		// 		}
		// 		return;
		// 	}

		// },
		hideAddClient(){
			this.showAddClient = false;
		},
		clioShowModal(){
			this.showClioModal = true;
		},
		hideClioModal(){
			this.showClioModal = false;
			this.showAddClient = false;
			// this.loader()
		},
		loader(value){
			console.log("isLoading: ",value)
			this.clioLoading = value;
		},
		async deleteAgreement() {
			if (!this.deleteId) return;
			this.$store.dispatch('deleteAgreement', this.deleteId).then(() => {
				analytics.logEvent('agreement_deleted');
				this.$posthog.capture('agreement_deleted', {
					user_id: this.$store.state.user?.uid || null,
					role: this.$store.state.posthogRole || '',
					email: this.$store.state.user?.email || '',
					timestamp: new Date().toISOString(),
				});
				this.showDeleteConfirmation = false;
				this.checkedAgreements = this.checkedAgreements.filter(a=>a === this.deleteId)
			});
		},
		async duplicateAgreement(bvModalEvt) {
			const details = this.duplicateAgreementDetails;
			if (!details || Array.isArray(details) || Object.keys(details).length === 0) {
				if (bvModalEvt) bvModalEvt.preventDefault(); // keep modal open
				this.errorMessage('', 'Could not clone this file. Please try again.');
				return;
			}
			setTimeout(() => {
				this.$set(this.cloningStatus, this.duplicateAgreementDetails.id, true);
			}, 200);
			const sourceId = this.duplicateId;
			this.agreementData = this.duplicateAgreementDetails;
			this.$store.dispatch('createAgreement', {
				...this.agreementData,
				title: this.duplicateAgreementTitle,
				isSummaryOpened: false,
				meta:{...this.agreementData.meta, editing: false},
			}).then(async ({ id, error }) => {
				this.clonedId = id;
				if (error) {
				this.error = 'Something unexpected went wrong.';
				} else if (id) {
				try {
					await this.$store.dispatch('copyScheduleDocs', { sourceId, targetId: id });
				} catch (copyError) {
					console.error(copyError);
					this.errorMessage('', 'The file was copied, but its parenting schedule could not be. Please try again.');
				}
				this.iscloned=true;
				analytics.logEvent('agreement_created');
				}
			}).finally(() => {
				this.$set(this.cloningStatus, this.duplicateAgreementDetails.id, false);
			});
		},
		showDeleteModel(id,option) {
		if(this.trialExpired || this.isSubscriptionCancelled){
			this.showSubscriptionModal = true
		}
		else{
			this.formatDeleteModalContent(option);
			this.deleteId = id;
			this.showDeleteConfirmation = true;
			if(option === "multiple"){
				this.deleteMultiple = true
			}
			else if(option === "single"){
				this.deleteMultiple = false
			}
		}
		},
		async showDuplicateModel(agreement) {
			this.duplicateAgreementDetails = [];
			this.$set(this.cloningStatus, agreement.id, true);
			let data = null;
			try {
				data = await this.$store.dispatch('fetchAgreementForDuplicate', agreement.id);
			} catch (e) {
				data = null;
			} finally {
				this.$set(this.cloningStatus, agreement.id, false);
			}
			if (!data || Object.keys(data).length === 0) {
				// Block: modal never opens, so no blank clone can be created.
				this.errorMessage('', 'Could not load this file to clone. Please try again.');
				return;
			}
			this.duplicateAgreementDetails = data;
			this.duplicateId = agreement.id;
			this.duplicateAgreementTitle = agreement.title;
			this.showDuplicateConfirmation = true;
		},
		hideModal() {
			this.deleteId = null;
			this.showDeleteConfirmation = false;
			this.deleteMultiple = false
		},
		hideDuplicateModal() {
			this.duplicateId = null;
			this.showDuplicateConfirmation = false;
		},
		getSubscriptions(){
			if (this.user && !this.subscriptions)
				this.$store.dispatch('getSubscriptions', this.user);
		},
		addNewClient(){
		if(this.trialExpired || this.isSubscriptionCancelled){
			this.showSubscriptionModal = true;
		}
		else{
			// Check party user agreement limit (defensive check)
			if(this.hasReachedPartyAgreementLimit){
				this.showAgreementLimit = true;
				this.agreementLimitModalOptions={
					heading:'Agreement Limit Reached',
					message: "Your plan allows for 1 separation agreement. To create additional agreements, please contact support or upgrade your plan.",
					button: "View Subscription"
				}
				return;
			}

			if(this.validateSubscriptionLimitReached.limitReached){
						this.showAgreementLimit = true;
						this.agreementLimitModalOptions={
							heading:'Plan limit reached',
							message : `Oops! It looks like you've already created ${this.subscriptions[0].role.substring(0,1)} new agreements this month. Need to create more files fast? Upgrade to Pro and create unlimited new files whenever you need.`,
							button:"Upgrade Now"
						}
						return;
			} else if(this.validateTrialAgreementsEnded()){
				this.showAgreementLimit = true;
				
				// Check if user is a lawyer
				const currentRoleLevel = this.currentRoleLevel?.roleName;
				const isLawyer = currentRoleLevel === 'lawyer-level-1' || currentRoleLevel === 'lawyer-level-2';
				
				if(isLawyer){
					this.agreementLimitModalOptions={
						heading:'Trial Limit',
						message : "You're currently on a Divii Free Trial which only supports one client file. If you'd like to create more files, you can upgrade to a paid version of Divii.",
						button: "Subscribe"
					}
					return;
				} else {
					// Keep existing message for non-lawyers
					if(this.currentRoleLevel?.roleName === "client-level-2" || this.currentRoleLevel?.roleName === "client-level-3" ){
					this.agreementLimitModalOptions={
						heading:'Agreement Limit',
						message : "You are only able to add and comment on the Agreement that was shared with you. If you would like to create another version, please upgrade to a paid version of Divii.",
						button: "Subscribe"
					}
					return
				}
				else{
					this.agreementLimitModalOptions={
							heading:'Trial Limit',
							message : "You're currently on a Divii Free Trial which only supports one client file. If you'd like to create more files, you can upgrade to a paid version of Divii.",
							button: "Subscribe"
					}
					}
					return;
				}				
			} 

			if(localStorage.getItem('loginProvider') == 'CLIO' || localStorage.getItem('isClioFetch') == 'true'){
				this.showAddClient = true;
			} else {
				this.routeToCreateAgreement();
			}
		}
		},
		routeToCreateAgreement(){
			this.$router.push({ name: 'createAgreement' });
		},
		navigateToSubscription(){
			this.showAgreementLimit = false;
			this.$router.push({ name: 'subscription' });
		},
		// Limit modals whose cap an upgrade cannot raise just close (dismiss: true).
		handleAgreementLimitAction(){
			if(this.agreementLimitModalOptions.dismiss){
				this.showAgreementLimit = false;
				return;
			}
			this.navigateToSubscription();
		},
		validateTrialAgreementsEnded(){
			if(this.trialExpired){
				return true; // Trial expired, block
			}
			
			if(!this.trialActive){
				return false; // Not in trial (subscribed), allow
			}
			
			// Check if user is a lawyer
			const currentRoleLevel = this.currentRoleLevel?.roleName;
			const isLawyer = currentRoleLevel === 'lawyer-level-1' || currentRoleLevel === 'lawyer-level-2';
			
			if(isLawyer){
				// For lawyers in trial: Check TWO conditions
				// 1. Owned agreements count (create creates owned)
				const ownedAgreementsCount = this.filteredAgreements.filter(agreement => agreement.owner).length;
				
				// 2. Total agreements count (owned + shared)
				const totalAgreementsCount = this.filteredAgreements.length;
				
				// Block if: already have 1 owned OR total is 2 or more
				if(ownedAgreementsCount >= 1 || totalAgreementsCount >= 2){
					return true; // Block creation
				}
				
				return false; // Allow creation
			}
			
			// For non-lawyers, keep existing behavior
			return this.filteredAgreements.length > 0;
		},
		getMaxAgreementsAllowed(){
			let limitForAgreements = null;
				if((this.subscriptions && this.subscriptions[0].role) && (this.subscriptions[0].role.includes('monthly'))){
					limitForAgreements = parseInt(this.subscriptions[0].role.substring(0,1));
				}
			return limitForAgreements;
		},
		formatDeleteModalContent(option){
			const maxLimit = this.getMaxAgreementsAllowed();
			if(option === "single"){
				this.agreementDeleteModalOptions= {
				heading:'Delete Agreement?',
				message:'Are you sure you want to permanently destroy this agreement?',
				}
			}
			if(option === "multiple"){
				this.agreementDeleteModalOptions= {
				heading:'Delete Agreements?',
				message:'Are you sure you want to permanently destroy selected agreements?',
				}
			}
			if(maxLimit){
				this.agreementDeleteModalOptions['message'] += `Keep in mind that on your current plan you can only create ${maxLimit} new agreements per billing cycle.`
			}
		},
		handleSelectAll(checked) {
			if (checked) {
				this.checkedAgreements = this.searchResults.filter(a=> a.owner).map(a => a.id)
			} else {
				this.checkedAgreements = []
			}
		},
		async deleteMultipleAgreements(){
			if (!this.checkedAgreements) return;
			this.deleteLoader = true
			this.$store.dispatch('deleteMultipleAgreements', this.checkedAgreements).then(() => {
				analytics.logEvent('agreements_deleted');
				this.$posthog.capture('multiple_agreement_deleted', {
					user_id: this.$store.state.user?.uid || null,
					role: this.$store.state.posthogRole || '',
					emil: this.$store.state.user?.email || '',
					timestamp: new Date().toISOString(),
				});
				this.showDeleteConfirmation = false;
				this.checkedAgreements = [];
				this.deleteLoader = false
			})
			.catch((error) => {
			console.error('An error occurred while deleting agreements:', error);
			this.deleteLoader = false;
			});
		},
		sortCompare(a, b, sortBy) {
			if (sortBy === 'name') {
				const nameA = a.title.toLowerCase()
				const nameB = b.title.toLowerCase()
				if (nameA < nameB) return -1
				if (nameA > nameB) return 1
				return 0
			} else if (sortBy === 'updatedAt') {
				const dateA = new Date(a.updatedAt)
				const dateB = new Date(b.updatedAt)
				return dateB - dateA
			} else {
				return a[sortBy] - b[sortBy]
			}
		},
		isDuplicationAllowed(agreement){
		// Client / separating-party path. Runs BEFORE the trialExpired hard-block below:
		// trialExpired ignores one-time `payments`, so a paid party user would be wrongly blocked by it.
		const clientRole = this.currentRoleLevel?.roleName;

		if(clientRole === 'client-sharing-user'){
			this.showAgreementLimit = true;
			this.agreementLimitModalOptions = {
				heading:'Trial Limit',
				message:"You're currently on a plan which does not support duplication. If you'd like to duplicate agreements, you can upgrade to a paid version of Divii.",
				button:'Subscribe'
			};
			return;
		}

		if(['client-level-1','client-level-2','client-level-3','client-level-5'].includes(clientRole)){
			// Party users pay via one-time payments; everyone else via a subscription.
			const isParty = this.currentRoleLevel?.roleAssociated === 'party';
			const paid = isParty ? (this.payments || []).length > 0 : this.hasActiveSubscription;

			// client-level-2 (shared spouse) may duplicate even on trial; all others must have paid.
			if(clientRole !== 'client-level-2' && !paid){
				this.showAgreementLimit = true;
				this.agreementLimitModalOptions = {
					heading:'Trial Limit',
					message:"You're currently on a Divii Free Trial which does not support duplication. If you'd like to make your own copy, you can upgrade to a paid version of Divii.",
					button:'Subscribe'
				};
				return;
			}

			// Owners hold their original (limit 2 => one copy); shared users hold none (limit 1 => one copy).
			const allowedDuplicates = clientRole === 'client-level-1' ? 2 : 1;
			if(this.filteredAgreements.filter(a => a.owner).length < allowedDuplicates){
				this.showDuplicateModel(agreement);
				return;
			}

			// A client's cap is fixed by role, not by plan — upgrading would not raise it,
			// so this modal dismisses instead of sending them to the subscription page.
			this.showAgreementLimit = true;
			this.agreementLimitModalOptions = {
				heading:'Duplication Limit',
				message:'You have reached the maximum number of agreements for your role. To make another copy, delete an agreement you no longer need.',
				button:'OK',
				dismiss: true
			};
			return;
		}

		if(this.trialExpired || this.isSubscriptionCancelled){
			this.showSubscriptionModal = true;
			return;
		}
		
		// Check if user is a lawyer
		const currentRoleLevel = this.currentRoleLevel?.roleName;
		const isLawyer = currentRoleLevel === 'lawyer-level-1' || currentRoleLevel === 'lawyer-level-2';
		
		// NEW LOGIC: For lawyers in trial
		if(this.trialActive && isLawyer){
			// For lawyers in trial: Check TWO conditions
			// 1. Owned agreements count (duplicate creates owned)
			const ownedAgreementsCount = this.filteredAgreements.filter(agreement => agreement.owner).length;
			
			// 2. Total agreements count (owned + shared)
			const totalAgreementsCount = this.filteredAgreements.length;
			
			// Block if: already have 1 owned OR total is 2 or more
			if(ownedAgreementsCount >= 1 || totalAgreementsCount >= 2){
				this.showAgreementLimit = true;
				this.agreementLimitModalOptions={
					heading:'Trial Limit',
					message : "You're currently on a Divii Free Trial which only supports one client file. If you'd like to create more files, you can upgrade to a paid version of Divii.",
					button: "Subscribe"
				}
				return;
			}
			
			// Allow duplication
			this.showDuplicateModel(agreement);
			return;
		}
		
		// EXISTING LOGIC: For subscribed users (not in trial) or non-lawyers in trial (non-shared)
		// This handles both subscribed users and party users in trial
		// Lawyers in trial already returned above, so this code runs for everyone else
		const allowedAgreements = this.getMaxAgreementsAllowed();
			
			if (this.currentRoleLevel.roleName === 'lawyer-level-1' || this.currentRoleLevel.roleName === 'lawyer-level-2') {
				if (allowedAgreements) {
					const agreementsInCurrentTimePeriod = this.agreements.filter(agreement => 
						this.dateLiesInsideDateRange(
							this.subscriptions[0].current_period_start.seconds,
							this.subscriptions[0].current_period_end.seconds,
							agreement.createdOn
						)
					);
					
					if (allowedAgreements <= agreementsInCurrentTimePeriod.length) {
						this.showAgreementLimit = true;
						this.agreementLimitModalOptions = {
							heading: 'Duplication Limit',
							message: 'You have reached your duplication limit for your current role and subscription level.',
							button: 'Upgrade'
						};
						return;
					}
					
					this.showDuplicateModel(agreement);
					return;
				}
			}
			
			let allowedDuplicates = 0;
			
			switch (this.currentRoleLevel.roleName) {
				case 'lawyer-level-1':
					allowedDuplicates = this.trialActive ? 0 : (allowedAgreements || Infinity);
					break;
				case 'lawyer-level-2':
					allowedDuplicates = this.trialActive ? 1 : (allowedAgreements || Infinity);
					break;
				// client-* roles return earlier in this method (see client / separating-party path)
				default:
					allowedDuplicates = 0;
			}
		let userOwnedAgreements = this.filteredAgreements.filter(agreement => agreement.owner);
		if (userOwnedAgreements.length < allowedDuplicates) {
			this.showDuplicateModel(agreement);
		} else {
			this.showAgreementLimit = true;
			this.agreementLimitModalOptions = {
				heading: 'Duplication Limit',
				message: 'You have reached your duplication limit for your current role and subscription level.',
					button: 'Upgrade'
			};
		}
	}
	},
	computed: {
		...mapState(['user','agreements', 'userProfile','subscriptions','currentAgreementRoleLevelName','storeIsSharedUser','customerDetails','currentRoleLevel','currentRoleLevel']),
		...mapGetters(['activePaymentForSeparatingParty']),
		loadingAgreements() {
			this.showLearnButton = ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
			return this.$store.getters.loading;
		},

		canDeleteAgreement() {
			return (agreement) => {
				return agreement.owner || 
					(!agreement.owner && (agreement.role === 'client-level-1' || agreement.role === 'lawyer-level-1'));
			};
		},
		filteredAgreements() {
			return this.agreements.filter(({ archived }) => !archived);
		},
		agreementsCountLeft(){
			return this.validateSubscriptionLimitReached.agreementsLeft >= 0 ? this.validateSubscriptionLimitReached.agreementsLeft : null;
		},
		// canCreate() {
		// 	console.log('subscriptions',this.subscriptions[0].role)
		// 	return (this.trialActive && this.filteredAgreements.length > 0) ||
		// 		this.trialExpired
		// 		? false
		// 		: true;
		// },
		validateSubscriptionLimitReached(){
			const allowedAgreements = this.getMaxAgreementsAllowed();
			let limitResponse = {
				limitReached : false,
				agreementsLeft: null
			};
			if(allowedAgreements){
					// let agreementsInCurrentTimePeriod = this.filteredAgreements.filter(agreement=> this.dateLiesInsideDateRange(this.subscriptions[0].current_period_start.seconds,this.subscriptions[0].current_period_end.seconds,agreement.createdOn) == true)
					let agreementsInCurrentTimePeriod = this.agreements.filter(agreement=> this.dateLiesInsideDateRange(this.subscriptions[0].current_period_start.seconds,this.subscriptions[0].current_period_end.seconds,agreement.createdOn) == true && agreement.owner)
					limitResponse['agreementsLeft'] = allowedAgreements - agreementsInCurrentTimePeriod.length;
					if(allowedAgreements <= agreementsInCurrentTimePeriod.length){
						limitResponse['limitReached']= true;
						return limitResponse
					}
			}
			return limitResponse;
		},
		searchResults(){
			if (this.searchTerm && this.searchTerm.length >= 3) {
				const searchWords = this.searchTerm.trim().toLowerCase().split(' ');
				return this.filteredAgreements.filter(result => {
					const title = result.title.toLowerCase();
					return searchWords.every((word) => title.includes(word));
				});
			} else {
				return this.filteredAgreements;
			}
		},
		isViewMode(){return !hasEditPermission('agreements')}, 
		isAddAllowed(){return hasAddPermission('agreements')},
		isDeleteAllowed(){return hasDeletePermission('agreements')},
		// Check if party user has reached agreement limit (1 owned agreement)
		hasReachedPartyAgreementLimit() {
			if (this.currentRoleLevel?.roleAssociated !== 'party') {
				return false;
			}
			// Count only owned agreements, not shared ones
			const ownedAgreementsCount = this.filteredAgreements.filter(agreement => agreement.owner).length;
			return ownedAgreementsCount >= 1;
		},
		// Check if "Add Agreement" button should be shown
		showAddAgreementButton() {
			if (this.currentRoleLevel?.roleAssociated === 'party') {
			// Wait for data to load before showing button
			if (!this.userProfile || this.userProfile.trialEnd === undefined) {
				return false; // Still loading userProfile data
			}
			if (this.subscriptions === null) {
				return false; // Still loading subscription data
			}
				return !this.hasReachedPartyAgreementLimit;
			}
			return this.isAddAllowed && !this.loadingAgreements;
		},
		// Check if duplicate button should be shown
		// Everyone except client-sharing-user sees it; isDuplicationAllowed is the real gate.
		showDuplicateButton() {
			return this.currentRoleLevel?.roleName !== 'client-sharing-user';
		},
		subsciptionModalMode(){
			if(this.trialExpired){
				return 'trialExpired'
			}
			else if(this.isSubscriptionCancelled){
				return 'subscriptionCancelled'
			}
		}
	},
	mounted() {
		this.getSubscriptions();
		this.$root.$emit('agreements-list-loaded');
	},
	mixins: [formatDate, trialHelpers,subsciptionHelpers, toast],
	watch: {
		selectAll(checked) {
			this.handleSelectAll(checked)
		},
	},
};
</script>

<style>
.nameColumn {
	width: 45%;
	background-position: left calc(9.75rem /2) center !important;
}

.home-wrapper {
	z-index: 2;
	min-height: 100vh;
	width: calc(100% + 5vw) ;
	margin-left: -2.5vw;
}

.circle-one {
	fill: #d4f0f0;
	opacity: 1;
	left: -40px;
	top: 100px;
	position: absolute;
}

.circle-two {
	fill: #e1efba;
	opacity: 0.6;
	left: 100px;
	top: 480px;
	position: absolute;
}

.circle-three {
	fill: #e1efba;
	opacity: 0.6;
	right: 80px;
	top: 150px;
	position: absolute;
}

.circle-four {
	fill: #d4f0f0;
	opacity: 0.6;
	right: 185px;
	top: 500px;
	position: absolute;
}

.circle-five {
	fill: #e1efba;
	opacity: 0.6;
	left: -80px;
	top: 50px;
	position: absolute;
}

.circle-six {
	fill: #d4f0f0;
	opacity: 1;
	left: -85px;
	top: 180px;
	position: absolute;
}

.container{
	margin-bottom: 1rem;
}
.clio-import{
	padding-right: 5px;
}
/* .custom-select{
	width: 40% !important;
} */
#deleteAgreement .modal-body{
	text-align: center;
}
.btn-color{
	background-color: #3F6772;
}
.new-client{
	/* width: 100%; */
	float: right;
}

.delete-multiple, .delete-multiple:disabled, .delete-multiple:focus{
	border-color: #d83c2d;
	color: #d83c2d;
	background-color: white;
	white-space: nowrap;
	padding: 2px 8px;
	font-weight: 400;
	font-size: 1rem;
	margin-right: 8px;
}

th.duplicateColumn{
	padding-right: 0px !important;
}

.delete-multiple:hover, .delete-multiple:not(:disabled):not(.disabled):active{
	background-color: #d83c2d;
	border-color: white;
	color: white;
}
.clio-client{
	/* width: 100%; */
	float: left;
}
/* .duplicate, .duplicate:focus{
	background-color: rgb(108, 117, 125) !important;
} */
.delete-multiple:focus, .delete-multiple.focus, .delete-multiple:not(:disabled):not(.disabled):active:focus{
	-webkit-box-shadow: none;
	box-shadow: none;
}

.dateColumn, .descriptionColumn{
	background-position: left calc(14.75rem /2) center !important;
	width: 272px;
	/* white-space: nowrap; */
}
/*.table td.descriptionColumn, .table td.dateColumn{
	font-size: 12px !important;
}*/

.description-container {
    max-height: calc(7 * 1.4em); 
    overflow: hidden;
    position: relative; 
}

.description {
    white-space: pre-line; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}

.nameColumn > div, 
.dateColumn > div, 
.descriptionColumn > div
{
	padding-bottom: 4px;
}

[role="columnheader"]{
	vertical-align: middle !important;
	padding: 8px !important;
}

th.checkbox[role="columnheader"]{
	padding: 12px !important;
}

.searchbar > .input-group-prepend > .input-group-text{
	background-color: transparent;
	color: #b8bdc0;
	border: none;
}

.searchinput{
	border: none;
}

.searchinput:focus{
	box-shadow: none !important;
}

.searchbar{
	border: 1px solid;
	border-color: #b8bdc0;
	border-radius: 5px;
}

::-webkit-search-cancel-button{
	cursor: pointer;
}

@media screen and (max-width: 565px) {
	.deleteColumn, .duplicateColumn {
		display:flex;
		flex-direction: column;
	}
}

@media (max-width: 992px) {
	.dateColumn {
    	background-position: left calc(11.45rem /2) center !important;
	}
}

@media (min-width: 768px) {
	.dateColumn {
		white-space: nowrap;
	}
}
@media(min-width: 320px) and (max-width: 395px) {
	.searchbar{
		width: 100%; 
	}
	.justify-content-end{
		-webkit-box-pack: justify !important;
		justify-content: space-between !important;
	}
	.nameColumn, .dateColumn, .deleteColumn, .duplicateColumn{
		padding-left: 10px !important;
	}
	.nameColumn > div{
		width: 5rem;
		background-position: left calc(9rem /2) center !important;
		text-align-last: center;
	}
	.dateColumn > div{
		width: 4.25rem;
	}
	.deleteColumn > .float-styling, .duplicateColumn > .float-styling{
		float: left;
	}
	.nameColumn,.deleteColumn,.checkbox, .duplicateColumn, .dateColumn{
		vertical-align: middle !important;
	}
	.dateColumn{
		text-align: center;
	}
	.col-5-mob{
		-webkit-box-flex: 0 !important;
		flex: 0 0 49% !important;
		max-width: 49% !important;
		padding-right: 0px !important;
	}
	.deleteColumn{
		max-width: 3.75rem;
	}
	.nameColumn{
		max-width: 6rem;
	}
	.dateColumn{
		max-width: 7rem;
	}
}
@media (min-width: 768px) {
	.dateColumn {
		white-space: nowrap;
	}
}

@media(min-width: 395px) and (max-width: 480px) {
	.searchbar{
		width: 100%; 
	}
	.justify-content-end{
		-webkit-box-pack: justify !important;
		justify-content: space-between !important;
	}
	.nameColumn, .dateColumn, .deleteColumn, .duplicateColumn{
		padding-left: 10px !important;
	}
	.nameColumn > div{
		width: 5rem;
		background-position: left calc(9rem /2) center !important;
		text-align-last: center;
	}
	.dateColumn > div{
		width: 4.25rem;
	}
	.deleteColumn > .float-styling, .duplicateColumn > .float-styling{
		float: left;
	}
	.nameColumn,.deleteColumn,.checkbox, .duplicateColumn, .dateColumn{
		vertical-align: middle !important;
	}
	.dateColumn{
		text-align: center;
	}
	.col-5-mob{
		-webkit-box-flex: 0 !important;
		flex: 0 0 54.66666667% !important;
		max-width: 55.66666667% !important;
		padding-right: 0px !important;
	}
	.deleteColumn{
		max-width: 4.063rem;
	}
	.nameColumn {
		max-width: 6rem;
	}
	.dateColumn{
		max-width: 7rem;
	}
}
@media (min-width: 768px) {
	.dateColumn {
		white-space: nowrap;
	}
}

@media(min-width: 481px) and (max-width: 2400px){
	/* .deleteColumn > .float-styling, .duplicateColumn > .float-styling{
		float: right;
	} 
	.home-wrapper {
		min-width: 400px;
	} */
	td.duplicateColumn{
		display: flex !important;
		flex-direction: row !important;
		justify-content: space-around !important;
		gap:30px !important;
	}
}

@media screen and (max-width: 509px) {
	.checkbox , .dateColumn {
		display: none;
	}

	.nameColumn > div, .descriptionColumn > div {
		padding: 8px !important;
	}

	th.deleteColumn , th.duplicateColumn{
		display: none;
	}

	[role="columnheader"] {
		vertical-align: bottom !important;
	}

	[role="table"] {
		border-top: 1px solid #dee2e6;
	}

	td.dateColumn , td.duplicateColumn {
		border-top: none !important;
	}

	td.duplicateColumn{
		display: flex;
		flex-direction: column;
		gap: 5px;
	}
}

</style>

<template>
	<b-container class="mt-5">
		<trial-banner />
		<b-card class="home-wrapper">
			<div slot="header" class="section-heading">
				<h4>Agreement Listing</h4>
				<a href="#" onclick="Intercom('showArticle', 11202173)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
			</div>
			<b-row>
				<b-col class="text-right mb-3 d-flex justify-content-end">
					<div class="col-4 col-5-mob">
						<b-input-group class="searchbar" v-if="filteredAgreements.length>0 && !loadingAgreements">
							<b-input-group-prepend is-text>
								<b-icon-search></b-icon-search>
							</b-input-group-prepend>
							<b-form-input
								type="search"
								placeholder="Search by client names"
								class="searchinput"
								v-model="searchTerm"
								data-testid="search-agreements"
							/>
						</b-input-group>
					</div>
					<b-button class="btn-color" variant="primary" @click="addNewClient()" v-if="showAddAgreementButton" data-testid="add-new-client-method"
						:class="{'btn-disabled-but-clickable': (isSubscriptionCancelled || trialExpired)}">
						+ New Agreement
						<b-badge variant="light" v-if="agreementsCountLeft!=null && agreementsCountLeft!=undefined">{{agreementsCountLeft}} left</b-badge>
					</b-button>
				</b-col>
				
			</b-row>
			<!-- <b-row>{{trialActive}} == {{filteredAgreements.length}} ++ {{trialExpired}}</b-row> -->
			<b-table show-empty :items="searchResults" :fields="fields" :sort-compare="sortCompare" sort-icon-left>
				<template #head(checkbox) v-if="isDeleteAllowed">
					<b-form-checkbox v-if="searchResults.length>0" v-model="selectAll" data-testid="select-all-checkbox"/>
				</template>
				<template #head(delete)>
					<!-- Delete selected button is moved to duplicate heading tag for better UI -->
				</template>
				<!-- Delete button moved to duplicate heading tag because to set alignment -->
				<template #head(duplicate)>
					<b-button size="sm" :style="{ visibility: checkedAgreements.length>0 ? 'visible' : 'hidden' }" @click="showDeleteModel(checkedAgreements,'multiple')" class="delete-multiple btn-color" :disabled="deleteLoader" variant="primary">
						<template v-if="deleteLoader">
						<b-spinner small type="grow"></b-spinner>
							Deleting...
						</template>
						<template v-else>
							Delete selected
						</template>
					</b-button>
				</template>
				<template #cell(checkBox)="{ item: agreement }"  v-if="isDeleteAllowed">
                    <div v-if="canDeleteAgreement(agreement)">
                    <b-form-checkbox  v-model="checkedAgreements" :value="agreement.id"
                        :data-testid="`select-agreement-checkbox-${agreement.id}`"></b-form-checkbox>
                    </div>
                </template>
				<template #cell(name)="{ item: agreement }">
					<b-link
						:to="{
							name: 'agreement',
							params: { id: agreement.id },
						}"
						:disabled="isViewMode"
						>{{ agreement.title || agreement.id }} 
						</b-link
					>
					<b-badge v-if="iscloned && agreement.id==clonedId" variant="secondary">Cloned</b-badge>
					&nbsp;<b-icon-people-fill variant="navy" v-if="agreement.isAgreementShared"></b-icon-people-fill>
				</template>
				<template #cell(description)="{ item: agreement }">
					<div class="description-container">
						<div class="description ellipsis">{{ agreement.description }}</div>
					</div>
				</template>
				<template #cell(delete)="{ item: agreement }" v-if="isDeleteAllowed">
					<!-- Delete button is placed inside the duplicate table column for better UI alignment -->
                </template>
				<template #cell(duplicate)="{ item: agreement }" v-if="currentRoleLevel?.roleName !== 'client-sharing-user'">
					<!-- placing delete-icon inside duplicate table column to get better UI -->					
					<div class="delete-icon">
                    <b-button
                        v-if="canDeleteAgreement(agreement)"
                        variant="pastel-blue"
                        size="sm"
                        class="float-styling"
                        :class="{'btn-disabled-but-clickable': (isSubscriptionCancelled || trialExpired)}"
                        @click="showDeleteModel(agreement.id,'single')"
                        data-testid="delete-model"
                    >

                        <b-icon-trash />
                    </b-button>
					</div>
					<div class="duplicate-icon" v-if="showDuplicateButton">
							<b-button
							variant="pastel-blue"
							size="sm"
							class="float-styling duplicate"
							@click="isDuplicationAllowed(agreement)"
							data-testid="duplicate-model"
							:class="{'btn-disabled-but-clickable': (isSubscriptionCancelled || (isSubscriptionCancelled || trialExpired))}"
							>
							<template v-if="cloningStatus[agreement.id]">
								<b-spinner small type="grow"></b-spinner></template>
							<template v-else>
								<b-icon-back />
							</template>
							</b-button>
					</div>
				</template>
				<template #empty>
					<b-card no-body>
						<div
							v-if="loadingAgreements || clioLoading"
							class="
								text-center
								w-100
								d-flex
								justify-content-center
								align-items-center
							"
							style="height: 200px"
						>
							<b-spinner
								style="width: 3rem; height: 3rem"
								variant="primary"
								label="Loading..."
							/>
						</div>
						<b-card-body v-else class="text-center">
							<b-card-title>You have no agreements</b-card-title>
							<b-card-text>
								Divii looks simple, but has so much to offer.
							</b-card-text>
							<b-button
								variant="primary"
								@click="addNewClient()"
								v-if="isAddAllowed"
							>
								Create agreement
							</b-button>
						</b-card-body>
					</b-card>
				</template>
				<template>
					<div
						v-if="clioLoading"
						class="
							text-center
							w-100
							d-flex
							justify-content-center
							align-items-center
						"
						style="height: 200px"
					>
						<b-spinner
							style="width: 3rem; height: 3rem"
							variant="primary"
							label="Loading..."
						/>
					</div>
				</template>
			</b-table>
			<b-modal
				id="deleteAgreement"
				v-model="showDeleteConfirmation"
				:title="agreementDeleteModalOptions.heading"
				@ok="deleteMultiple? deleteMultipleAgreements(): deleteAgreement()"
				@hide="hideModal"
				data-testid="delete-agreement"
				cancel-variant="pastel-blue"
			>
				<p>
					{{agreementDeleteModalOptions.message}}
				</p>
			</b-modal>

			<b-modal
				id="duplicateAgreement"
				v-model="showDuplicateConfirmation"
				title="You are about to clone a client file"
				@ok="duplicateAgreement"
				@hide="hideModal"
				data-testid="duplicate-agreement"
				cancel-variant="pastel-blue"
				size="lg"
				ok-title="Continue"
			>
				<ul>
					<li>Cloned files are not linked. Any changes made will only be reflected in the file you're editing.</li>
					<li>Collaborators on the original file will need to be manually invited to the cloned file</li>
					<li>We recommend adding a 'Description' when creating clones so that you can easily identify your working versions.</li>
				</ul>
			</b-modal>

			<b-modal
				id="agreementLimitTrial"
				v-model="showAgreementLimit"
				:title="agreementLimitModalOptions.heading"
				hide-footer
				@hide="showAgreementLimit = false"
			>
				<p>
					{{agreementLimitModalOptions.message}}
				</p>
				<div class="text-left mt-3">
					<b-button 
						variant="primary" 
						class="btn-primary"
						@click="handleAgreementLimitAction"
					>
						{{agreementLimitModalOptions.button}}
					</b-button>
				</div>
			</b-modal>

			<b-modal
				id="addClientMethods"
				v-model="showAddClient"
				title=" Import from Clio"
			>	
				Do you want to import agreement from Clio?
				<template #modal-footer="{}">
					<b-button size="sm" variant="primary" @click="clioShowModal()" data-testid="cancel-button"> Yes </b-button>
					<b-button size="sm" variant="navy" @click="routeToCreateAgreement()" data-testid="cancel-button"> No </b-button>
				</template>
					<!-- <b-form-group >
						<div class="clio-client"> -->
							<!-- <b-button class="bg-color mt-3" variant="navy" @click="clioShowModal()" data-testid="import-clio-file-btn">
									Yes
							</b-button>
							<b-badge href="#" variant="light" v-if="agreementsCountLeft!=null && agreementsCountLeft!=undefined">{{agreementsCountLeft}} left</b-badge> -->
							<template v-if="showClioModal"><clio-import
							title= "Import Clio File"
							:show-clio-modal="showClioModal"
							:hide-clio-modal="hideClioModal"
							:save-details="saveDetails"
							@isLoading="loader"
							class="modal-body"
							/></template>
						<!-- </div> -->
						<!-- <div class="new-client">
							<b-link class="btn btn-primary mt-3" @click="addNewClient()" v-if="!loadingAgreements" data-testid="add-new-client">
								No
								<b-badge href="#" variant="light" v-if="agreementsCountLeft!=null && agreementsCountLeft!=undefined">{{agreementsCountLeft}} left</b-badge>
							</b-link>
						</div> -->
					<!-- </b-form-group> -->
			</b-modal>
		</b-card>
		
		<!-- <div class="circle-one">
			<svg
				preserveAspectRatio="none"
				data-bbox="0 0 200 200"
				xmlns="http://www.w3.org/2000/svg"
				width="200"
				height="200"
				viewBox="0 0 200 200"
				role="presentation"
				aria-hidden="true"
			>
				<g>
					<path
						d="M200 100c0 55.228-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0s100 44.772 100 100z"
					></path>
				</g>
			</svg>
		</div>
		<div class="circle-two">
			<svg
				preserveAspectRatio="none"
				data-bbox="0 0 200 200"
				xmlns="http://www.w3.org/2000/svg"
				width="162"
				height="162"
				viewBox="0 0 200 200"
				role="presentation"
				aria-hidden="true"
			>
				<g>
					<path
						d="M200 100c0 55.228-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0s100 44.772 100 100z"
					></path>
				</g>
			</svg>
		</div>
		<div class="circle-three">
			<svg
				preserveAspectRatio="none"
				data-bbox="0 0 200 200"
				xmlns="http://www.w3.org/2000/svg"
				width="162"
				height="162"
				viewBox="0 0 200 200"
				role="presentation"
				aria-hidden="true"
			>
				<g>
					<path
						d="M200 100c0 55.228-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0s100 44.772 100 100z"
					></path>
				</g>
			</svg>
		</div>
		<div class="circle-four">
			<svg
				preserveAspectRatio="none"
				data-bbox="0 0 200 200"
				xmlns="http://www.w3.org/2000/svg"
				width="275"
				height="275"
				viewBox="0 0 200 200"
				role="presentation"
				aria-hidden="true"
			>
				<g>
					<path
						d="M200 100c0 55.228-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0s100 44.772 100 100z"
					></path>
				</g>
			</svg>
		</div> -->
		<subscription-modal :showSubscriptionModal="showSubscriptionModal" @close="showSubscriptionModal = false" :mode="subsciptionModalMode"/>
	</b-container>
</template>